<template>
  <div>
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading2">
      <div id="admin-loader-text">Deleting</div>
      <div id="admin-loader"></div>
    </div>

    <div v-if="changed">
      <div class="m-auto text-right pt-3">
        <el-button
          @click="dialogFormVisible2 = true"
          type="primary"
          size="medium"
        >
          <i class="el-icon-plus mr-2"></i>Add Supplier</el-button
        >
      </div>
      <div class="col-sm-12 col-md-8 col-lg-6 m-auto pl-4">
        <el-dialog
          title="Add Supplier"
          :visible.sync="dialogFormVisible2"
          :width="width"
        >
          <!-- <h4 class="text-center pt-4 pb-3">Add Supplier</h4> -->
          <el-card shadow="always" style="background-color: #f5f7fa">
            <el-form
              :model="formdata"
              status-icon
              :rules="rules2"
              ref="formdata"
              label-width="120px"
              :label-position="labelPosition"
              size="medium"
              style="
                <!-- border: 1px solid #e2e2e2;
                border-radius: 5px; -->
                background-color: #fff;
                padding: 25px;
              "
            >
              <el-form-item
                label="Name"
                prop="name"
                :rules="[
                  { required: true, message: 'Supplier name', trigger: 'blur' },
                ]"
              >
                <el-input placeholder="Name" v-model="formdata.name"></el-input>
              </el-form-item>

              <el-form-item
                label="Telephone Without 0"
                prop="telephone"
                :rules="[
                  { required: true, message: 'telephone no is required' },
                  { type: 'number', message: 'telephone no must be a number' },
                ]"
              >
                <el-input
                  v-model.number="formdata.telephone"
                  auto-complete="off"
                  placeholder="Telephone"
                  @change="checkTelephone(formdata, 'create')"
                ></el-input>
              </el-form-item>
              <el-form-item label="City/Town" prop="city">
                <el-input
                  placeholder="City/Town"
                  v-model="formdata.city"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="email"
                label="Email"
                :rules="[
                  {
                    type: 'email',
                    message: 'Please input correct email address',
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-input
                  placeholder="Email"
                  type="email"
                  v-model="formdata.email"
                ></el-input>
              </el-form-item>
              <el-form-item label="Notes" prop="note">
                <el-input type="textarea" v-model="formdata.note"></el-input>
              </el-form-item>

              <el-form-item class="pt-2" style="margin-bottom: 0px">
                <el-button type="primary" @click="submitForm('formdata')"
                  >Add</el-button
                >
                <el-button @click="resetForm('formdata')">Reset</el-button>
              </el-form-item>
            </el-form>
          </el-card>
          <span slot="footer" class="dialog-footer">
            <el-button type="danger" @click="dialogFormVisible2 = false"
              >Cancel</el-button
            >
            <!-- <el-button type="primary" @click="submitForm('formdata')">Add</el-button> -->
          </span>
        </el-dialog>
      </div>
      <div class="col-sm-12 col-md-8 col-lg-6 m-auto pl-4">
        <el-dialog
          title="Edit Supplier"
          :visible.sync="dialogFormVisible3"
          :width="width"
        >
          <!-- <h4 class="text-center pt-4 pb-3">Add Supplier</h4> -->
          <el-form
            :model="formdata2"
            status-icon
            :rules="rules2"
            ref="formdata2"
            label-width="120px"
            :label-position="labelPosition"
            size="medium"
            style="
              border: 1px solid #e2e2e2;
              border-radius: 5px;
              background-color: #fff;
              padding: 25px;
            "
          >
            <el-form-item
              label="Name"
              prop="name"
              :rules="[
                { required: true, message: 'Supplier name', trigger: 'blur' },
              ]"
            >
              <el-input placeholder="Name" v-model="formdata2.name"></el-input>
            </el-form-item>

            <el-form-item
              label="Telephone Without 0"
              prop="telephone"
              :rules="[
                { required: true, message: 'telephone no is required' },
                { type: 'number', message: 'telephone no must be a number' },
              ]"
            >
              <el-input
                v-model.number="formdata2.telephone"
                auto-complete="off"
                @change="checkTelephone(formdata2, 'update')"
                placeholder="Telephone"
              ></el-input>
            </el-form-item>
            <el-form-item label="City/Town" prop="city">
              <el-input
                placeholder="City/Town"
                v-model="formdata2.city"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="email"
              label="Email"
              :rules="[
                {
                  type: 'email',
                  message: 'Please input correct email address',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                placeholder="Email"
                type="email"
                v-model="formdata2.email"
              ></el-input>
            </el-form-item>
            <el-form-item label="Notes" prop="note">
              <el-input type="textarea" v-model="formdata2.note"></el-input>
            </el-form-item>

            <el-form-item class="pt-2" style="margin-bottom: 0px">
              <el-button type="primary" @click="update('formdata2')"
                >Update</el-button
              >
              <!-- <el-button @click="resetForm('formdata2')">Reset</el-button> -->
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="danger" @click="dialogFormVisible3 = false"
              >Cancel</el-button
            >
            <!-- <el-button type="primary" @click="submitForm('formdata')">Add</el-button> -->
          </span>
        </el-dialog>
      </div>
      <b-container class="col-lg-10 mt-1">
        <h3 class="text-info text-center my-4">Suppliers</h3>
        <!-- User Interface controls -->
        <b-row>
          <b-col sm="4" class="my-1">
            <b-form-group label="" class="mb-0">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col sm="5" class="my-1">
            <b-form-group label="" class="mb-0">
              <b-input-group>
                <b-form-select v-model="sortBy" :options="sortOptions">
                  <option slot="first" :value="null">Sort By</option>
                </b-form-select>
                <b-form-select
                  :disabled="!sortBy"
                  v-model="sortDesc"
                  slot="append"
                >
                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col sm="3" class="my-1">
            <b-form-group horizontal class="mb-0">
              <b-form-select v-model="perPage">
                <option disabled>per page</option>
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Main table element -->
        <el-card style="overflow-x: scroll;" shadow="always">
          <b-table
            show-empty
            stacked="sm"
            :items="items"
            :fields="fields"
            :hover="true"
            head-variant="dark"
            :dark="false"
            :small="true"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :empty-text="emptyText"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @filtered="onFiltered"
            class="mt-4"
          >
            <!-- <template slot="index" slot-scope="data">
          {{data.index + 1}}
        </template> -->

            <template slot="id" slot-scope="row">
              <div>{{ row.value }}</div>
            </template>

            <template slot="actions" slot-scope="row">
              <!-- <div class="btn-group" role="group" aria-label="Basic example">
            
              <a @click.stop="row.toggleDetails"><el-button type="primary" size="mini">View</el-button></a>
              <a :href="`tel:${row.item.telephone}`" ><el-button type="success" size="mini">Call</el-button></a>
              <a :href="`sms:${row.item.telephone}`"><el-button type="info" size="mini">SMS</el-button></a>
            
          </div> -->
              <div class="btn-group" role="group" aria-label="Basic example">
                <!-- <a
                  size="sm"
                  @click.stop="row.toggleDetails"
                  class="btn btn-sm btn-primary text-white"
                >
                  View
                </a> -->
                <a
                  size="sm"
                  @click="showUpdate(row.item)"
                  class="btn btn-sm btn-primary text-white"
                >
                  Edit
                </a>
                <a
                  :href="`tel:${row.item.telephone}`"
                  size="sm"
                  class="btn btn-sm btn-success text-white"
                >
                  Call
                </a>
                <a
                  :href="`sms:${row.item.telephone}`"
                  size="sm"
                  class="btn btn-sm btn-secondary text-white"
                >
                  SMS
                </a>
              </div>
            </template>

            <template slot="row-details" slot-scope="row">
              <div class="mx-auto">
                <!-- <el-button
                  type="primary"
                  size="small"
                  class="mt-3 d-block mx-auto"
                  @click="dialogFormVisible = true"
                  >Add Payment</el-button
                > -->
                <el-button
                  type="info"
                  size="small"
                  class="mt-1 d-block mx-auto"
                  @click="showUpdate(row.item)"
                  >Edit Details</el-button
                >
                <!-- <el-dialog
                  title="Add Payment"
                  :visible.sync="dialogFormVisible"
                  :width="width"
                >
                  <el-input-number
                    placeholder="Enter Amount"
                    v-model="amount"
                    :min="1"
                    :max="1000000000"
                  ></el-input-number>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false"
                      >Cancel</el-button
                    >
                    <el-button type="primary" @click="addPay(row.item.id)"
                      >Add</el-button
                    >
                  </span>
                </el-dialog> -->
                <!-- <h6 class="my-3 text-center">Payment History</h6>
                <el-timeline :reverse="true" class="">
                  <el-timeline-item
                    v-for="(p, index) in row.item.payments"
                    :key="index"
                    color="#fd7e14"
                    size="large"
                    :timestamp="p.d.toDate().toLocaleString()"
                  >
                    Rs {{ p.a }}
                  </el-timeline-item>
                </el-timeline> -->
              </div>
            </template>
          </b-table>
        </el-card>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-container>
    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
const items = [];
export default {
  name: "suppliers",
  data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: [
        { key: "name", label: "Name", sortable: true },
        { key: "telephone", label: "Telephone", sortable: false },
        { key: "city", label: "City", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "totalPayment", label: "Total (Rs)", sortable: true },
        { key: "totalRemaining", label: "Remaining (Rs)", sortable: true },
        // {
        //   key: "totalLoyalityPoints",
        //   label: "Loyalty Points (Rs)",
        //   sortable: true,
        // },
        { key: "regdate", label: "Registered", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      payments: [],
      amount: 0,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      width: "50%",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [10, 25, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading: false,
      loading1: false,
      loading2: false,
      changed: true,
      cus: 0,
      pay: 0,
      formdata: {
        name: "",
        email: "",
        city: "",
        pass: "",
        checkPass: "",
        telephone: "",
        note: "",
      },
      formdata2: {
        name: "",
        email: "",
        city: "",
        telephone: "",
        id: "",
        note: "",
      },
      rules2: {},
      labelPosition: "top",
    };
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    open1() {
      this.$notify.error({
        title: "Error",
        message: "Please Enter the Correct Details",
        type: "error",
      });
    },
    showUpdate(item) {
      this.formdata2.name = item.name;
      this.formdata2.telephone = item.telephone;
      this.formdata2.email = item.email;
      this.formdata2.city = item.city;
      this.formdata2.id = item.id;
      this.dialogFormVisible3 = true;
      this.formdata2.note = item.note;
    },

    checkTelephone(form, method) {
      if (form.telephone) {
        const docRef = this.$store.state.secondaryDatabase.collection("suppliers");
        let firestoreQuery = docRef;
        if(this.$store.state.noDB === true) {
          firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
        } 
        firestoreQuery
          .where("telephone", "==", form.telephone)
          .limit(1)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (method === "update") {
                if (form.id !== doc.id) {
                  const telephone = form.telephone;
                  form.telephone = "";
                  return this.$notify.error({
                    title: "Error",
                    message: "Telephone no " + telephone + " is already used",
                    type: "error",
                  });
                }
              } else {
                const telephone = form.telephone;
                form.telephone = "";
                return this.$notify.error({
                  title: "Error",
                  message: "Telephone no " + telephone + " is already used",
                  type: "error",
                });
              }
            });
          })
          .catch((error) => alert(error.message));
      }
    },

    update(fdata) {
      this.$refs[fdata].validate((valid) => {
        if (valid) {
          (this.dialogFormVisible3 = false), (this.changed = false);
          this.loading = true;
          ////console.log(user)
          this.$store.state.secondaryDatabase
            .collection("suppliers")
            .doc(this.formdata2.id)
            .update({
              name: this.formdata2.name,
              email: this.formdata2.email,
              city: this.formdata2.city,
              telephone: this.formdata2.telephone,
              note: this.formdata2.note,
            })
            .then((docRef) => {
              //console.log('docref', docRef.id)
              var newitems = this.items.filter((item) => {
                ////console.log('filfkkk')
                if (item.id == this.formdata2.id) {
                  item.name = this.formdata2.name;
                  item.telephone = this.formdata2.telephone;
                  item.email = this.formdata2.email;
                  item.city = this.formdata2.city;
                  item.note = this.formdata2.note;
                }
                return item;
              });
              this.$store.state.suppliers = newitems;
              this.formdata2.name = "";
              this.formdata2.telephone = "";
              this.formdata2.email = "";
              this.formdata2.city = "";
              this.formdata2.id = "";
              this.formdata2.note = "";
              this.loading = false;
              this.changed = true;
              this.$notify({
                title: "Success",
                message: "Supplier updated",
                type: "success",
              });
            })
            .catch((error) => alert(error));
        } else {
          this.open1();
          return false;
        }
      });
    },
    submitForm(fdata) {
      this.$refs[fdata].validate((valid) => {
        if (valid) {
          (this.dialogFormVisible2 = false), (this.changed = false);
          this.loading = true;
          ////console.log(user)
          this.$store.state.secondaryDatabase
            .collection("suppliers")
            .add({
              name: this.formdata.name,
              email: this.formdata.email,
              city: this.formdata.city,
              regdate: firebase.firestore.Timestamp.now(),
              //uid: firebase.auth().currentUser.uid,
              shopOwner: firebase.auth().currentUser.uid,
              telephone: this.formdata.telephone,
              totalPayment: 0,
              totalRemaining: 0,
              totalLoyalityPoints: 0,
              note: this.formdata.note,
            })
            .then((docRef) => {
              //console.log('docref', docRef.id)
              this.$store.state.suppliers.push({
                id: docRef.id,
                name: this.formdata.name,
                note: this.formdata.note,
                email: this.formdata.email,
                city: this.formdata.city,
                totalPayment: 0,
                totalRemaining: 0,
                totalLoyalityPoints: 0,
                regdate: firebase.firestore.Timestamp.now()
                  .toDate()
                  .toLocaleString(),
                //uid: firebase.auth().currentUser.uid,
                telephone: this.formdata.telephone,
                payments: [],
              });
              this.items = this.$store.state.suppliers;
              this.totalRows = this.items.length;
              this.cus = this.cus + 1;
              this.$store.state.secondaryDatabase
                .collection("shops")
                .doc(firebase.auth().currentUser.uid)
                .update({
                  supp: this.cus,
                })
                .then(() => {
                  //console.log('secondaryDB shop id')
                })
                .catch((error) => alert(error));
              this.formdata.name = "";
              this.formdata.email = "";
              this.formdata.telephone = "";
              this.formdata.city = "";
              this.formdata.note = "";
              this.loading = false;
              this.changed = true;
              this.$notify({
                title: "Success",
                message: "Supplier added",
                type: "success",
              });
            })
            .catch((error) => alert(error));
        } else {
          this.open1();
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    addPay(id) {
      this.dialogFormVisible = false;
      this.loading = true;
      this.changed = false;
      var newPay = [];
      var newitems = this.items.filter((item) => {
        ////console.log('filfkkk')
        if (item.id == id) {
          item.payments.push({
            a: this.amount,
            d: firebase.firestore.Timestamp.now(),
          });
          newPay = item.payments;
          item.total += this.amount;
        }
        return item;
      });
      this.$store.state.suppliers = newitems;
      this.$store.state.secondaryDatabase
        .collection("suppliers")
        .doc(id)
        .update({
          payments: newPay,
        })
        .then((docRef) => {
          this.pay = this.pay + this.amount;
          this.$store.state.secondaryDatabase
            .collection("shops")
            .doc(firebase.auth().currentUser.uid)
            .update({
              pay: this.pay,
            })
            .then(() => {
              //console.log('secondaryDB shop id')
            })
            .catch((error) => alert(error));
          this.loading = false;
          this.changed = true;
          this.$notify({
            title: "Success",
            message: "Payment added",
            type: "success",
          });
        })
        .catch((error) => alert(error));
    },
  },
  created() {
    this.loading1 = true;
    this.changed = false;
    if (screen.width > 767) {
      this.width = "50%";
    } else {
      this.width = "85%";
    }
    this.$store.state.secondaryDatabase
      .collection("shops")
      .doc(firebase.auth().currentUser.uid)
      .get()
      .then((doc) => {
        this.cus = doc.data().supp || 0;
        this.pay = doc.data().pay;
      })
      .catch((error) => alert(error));

    if (this.$store.state.suppliers.length != 0) {
      this.items = this.$store.state.suppliers;
      this.totalRows = this.items.length;
      this.loading1 = false;
      this.changed = true;
    } else {
      const docRef = this.$store.state.secondaryDatabase.collection("suppliers");
      let firestoreQuery = docRef;
      if(this.$store.state.noDB === true) {
        firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
      } 
      firestoreQuery
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              name: doc.data().name,
              email: doc.data().email,
              city: doc.data().city,
              regdate: doc.data().regdate,
              telephone: doc.data().telephone,
              payments: doc.data().payments,
              totalPayment: doc.data().totalPayment,
              totalRemaining: doc.data().totalRemaining,
              totalLoyalityPoints: doc.data().totalLoyalityPoints,
              note: doc.data().note,
            };
            if (data.regdate != undefined) {
              data.regdate = doc.data().regdate.toDate().toLocaleString();
            }
            if (data.payments != undefined) {
              var pays = [];
              data.payments.forEach((p) => {
                pays.push(p.a);
              });
              data.total = pays.reduce(add, 0);
              function add(a, b) {
                return a + b;
              }
              //console.log('total', data.total)
            }
            this.items.push(data);
            this.totalRows = this.items.length;
            this.$store.state.suppliers = this.items;
            this.$store.state.viewedSupplierPage = true;
          });
          if (this.items.length == 0) {
            this.emptyText = "There are no records to show";
          }
          this.loading1 = false;
          this.changed = true;
        });
    }
  },
};
</script>

<style scoped>
@import url("~@/assets/admin/css/admin-loader.css");
</style>




// WEBPACK FOOTER //
// src/components/admin/Suppliers.vue